(function(angular) {
    'use strict';

    angular.module('wtApp.dataService')
        .factory('InitPollJob', ['$injector', function($injector) {
            const $q = $injector.get('$q');
            const jobStatus = $injector.get('jobStatus');

            /**
             * @ngdoc service
             * @name InitPollJob
             * @description Builds init poll jobs queries
             */
            return class InitPollJob {
                /**
                 * @ngdoc method
                 * @name InitPollJob#constructor
                 * @param   {string} resultType
                 * @param   {string=} id
                 * @returns {InitPollJob}
                 */
                constructor(resultType, id = '') {
                    /**
                     * Inherit a fresh promise
                     */
                    Object.assign(this, $q.defer());

                    /**
                     * A unique identifier
                     * @type {string}
                     */
                    this.id = `${id}${Date.now()}`;

                    /**
                     * The result type of the job i.e. DATA_ONLY, CSV, PDF ect
                     * @type {string}
                     */
                    this.resultType = resultType;

                    /**
                     * Initial status of the job
                     * @type {Object}
                     */
                    this.status = jobStatus.JOB_INITIALISING;
                }

                /**
                 * @ngdoc method
                 * @name InitPollJob#abort
                 * @description Changes the status of the instance.
                 * @returns {InitPollJob}
                 */
                abort() {
                    this.status = jobStatus.JOB_ABORTED_BY_USER;
                    return this;
                }

                /**
                 * @ngdoc method
                 * @name InitPollJob#conclude
                 * @description Changes the status of the instance.
                 * @returns {InitPollJob}
                 */
                conclude() {
                    this.status = jobStatus.JOB_INITIALISING_CONCLUDED;
                    return this;
                }

                /**
                 * @ngdoc property
                 * @name InitPollJob#isAborted
                 * @description Determines if the init poll job was aborted by the user
                 * @returns {boolean}
                 */
                get isAborted() {
                    return jobStatus.isAbortedByUser(this.status);
                }
            };
        }]);
})(window.angular);
